export default __webpack_public_path__ + "static/governance-mlops-pmi-monitoraggio-sicurezza-compliance-5d753e113af24a4882a9f84d8d671fb5.jpg";